import { render, staticRenderFns } from "./BalancePlans.vue?vue&type=template&id=1e5bf4ae&scoped=true"
import script from "./BalancePlans.vue?vue&type=script&lang=js"
export * from "./BalancePlans.vue?vue&type=script&lang=js"
import style0 from "./BalancePlans.vue?vue&type=style&index=0&id=1e5bf4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5bf4ae",
  null
  
)

export default component.exports